import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
import { computed, inject, onBeforeMount, onMounted, ref, watch, } from "vue";
import OneDeskTable from "@/components/organisms/OneDeskTable.vue";
import { getWebPageTestTasksByPerimeterAndTypes } from "@/repositories/tasks.repository";
import { RequestTaskType } from "@/@types/requestTaskType";
import OneDeskWpDirectDownload from "@/components/molecules/OneDeskWpDirectDownload.vue";
import { useStore } from "@/shared/composables/useStore";
import WPLabels from "@/shared/json/wpLabels.json";
import { isKeyof } from "@/shared/utils/utils";
import { taskReportColumns } from "@/shared/utils/columns-definition/task-report";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import MultiSelect from "primevue/multiselect";
import Tag from "primevue/tag";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskReportTable',
    props: {
        requestType: { default: RequestTaskType.Website },
        data: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const reportColumnsDefinition = ref(taskReportColumns);
        const tasksList = ref([]);
        const totalCount = ref(0);
        const taskTypes = ref([]);
        const eventBus = inject("eventBus");
        const navLinks = computed(() => store.getters[ReferenceValuesTypes.NAVIGATIONMENU]);
        const pageIndex = ref(1);
        const pageSize = ref(10);
        const search = ref("");
        const enabledTestsForUser = computed(() => {
            return testTypesFilters.value.filter((test) => {
                return !test.slug || enabledLink(test.slug);
            });
        });
        onBeforeMount(() => getReportsAsync());
        onMounted(() => eventBus.on("refresh", () => getReportsAsync()));
        const enabledLink = (slug) => navLinks.value.find(nl => nl.code === slug) !== undefined;
        const testTypesFilters = ref([
            { name: "Load testing", slug: "load-testing", code: "wp1", icon: "pi pi-chart-line" },
            { name: "Page performance", slug: "page-performance", code: "wp4", icon: "pi pi-chart-bar" },
            { name: "Accessibility", slug: "accessibility", code: "wp6", icon: "pi pi-eye" },
            { name: "SEO", slug: "seo", code: "wp8", icon: "pi pi-search" },
        ]);
        const tasksCount = computed(() => {
            const tasks = (store.getters.getTasks ? store.getters.getTasks : []);
            return tasks.length;
        });
        const clearFilters = () => {
            taskTypes.value = [];
            search.value = "";
            pageIndex.value = 1;
        };
        watch(pageIndex, () => getReportsAsync());
        watch([taskTypes, pageSize, tasksCount, search], async () => {
            pageIndex.value = 1;
            await getReportsAsync();
        });
        watch(() => props.data, () => {
            pageIndex.value = 1;
            getReportsAsync();
        }, { deep: true });
        const getReportsAsync = async () => {
            let perimeterId = props.data.id;
            switch (props.requestType) {
                case RequestTaskType.Market:
                    perimeterId = props.data.market;
                    break;
                case RequestTaskType.Brand:
                    perimeterId = props.data.brand;
                    break;
            }
            const result = await getWebPageTestTasksByPerimeterAndTypes(props.requestType, perimeterId, taskTypes.value, search.value, pageIndex.value, pageSize.value);
            tasksList.value = result.items;
            totalCount.value = result.totalCount;
            pageIndex.value = result.pageIndex;
        };
        const getWpLabel = (wpType) => (isKeyof(WPLabels, wpType)) ? WPLabels[wpType] : wpType;
        const getWpIcon = (wpType) => {
            return testTypesFilters.value.find(e => e.code === wpType.toLowerCase())?.icon;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(OneDeskTable, {
                    title: "Reports",
                    "columns-definition": reportColumnsDefinition.value,
                    "table-data": tasksList.value,
                    class: "wp-reports-table",
                    "has-pagination": true,
                    "total-records": totalCount.value,
                    "has-filters": true,
                    "page-index": pageIndex.value,
                    "page-size": pageSize.value,
                    "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                    currentPageReportTemplate: "{first} to {last} of {totalRecords}",
                    onPageChange: _cache[1] || (_cache[1] = ($event) => (pageIndex.value = $event + 1)),
                    onSearchChange: _cache[2] || (_cache[2] = ($event) => (search.value = $event)),
                    onClearFilters: clearFilters
                }, {
                    filters: _withCtx(() => [
                        _createVNode(_unref(MultiSelect), {
                            modelValue: taskTypes.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((taskTypes).value = $event)),
                            placeholder: "Select test types",
                            options: enabledTestsForUser.value,
                            display: "chip",
                            "option-value": "code",
                            "option-label": "name"
                        }, null, 8, ["modelValue", "options"])
                    ]),
                    user: _withCtx((slotProps) => [
                        _createElementVNode("span", null, _toDisplayString(slotProps.item.user ? slotProps.item.user.displayName : ""), 1)
                    ]),
                    created: _withCtx((slotProps) => [
                        _createVNode(_unref(Tag), {
                            icon: "pi pi-calendar",
                            severity: "secondary",
                            value: new Date(slotProps.item.created).toLocaleString()
                        }, null, 8, ["value"])
                    ]),
                    taskType: _withCtx((slotProps) => [
                        _createVNode(_unref(Tag), {
                            icon: getWpIcon(slotProps.item.taskType),
                            severity: "info",
                            value: getWpLabel(slotProps.item.taskType)
                        }, null, 8, ["icon", "value"])
                    ]),
                    result: _withCtx((slotProps) => [
                        _createVNode(OneDeskWpDirectDownload, {
                            report: slotProps.item.result?.value
                        }, null, 8, ["report"])
                    ]),
                    status: _withCtx((slotProps) => [
                        (slotProps.item.status)
                            ? (_openBlock(), _createBlock(_unref(Tag), {
                                key: 0,
                                icon: slotProps.item.status === 'Succeeded' ? 'pi pi-fw pi-check-circle' : 'pi pi-fw pi-plus-circle',
                                severity: slotProps.item.status === 'Succeeded' ? 'success' : 'secondary',
                                value: slotProps.item.status
                            }, null, 8, ["icon", "severity", "value"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["columns-definition", "table-data", "total-records", "page-index", "page-size"])
            ]));
        };
    }
});
